import { ProcessInstance } from './process-instance';

/**
 * REST API model
 */
export class ProcessInstanceEntry {
  entry: ProcessInstance;

  constructor(input?: any) {
    if (input) {
      Object.assign(this, input);
      this.entry = input.entry ? new ProcessInstance(input.entry) : undefined;
    }
  }
}
